import React, {Component} from 'react'
import browserNotSupport from '../../../icon/browserNotSupport.png'
import FJLocalStore from "../../../store/FJLocalStore";
import FJButton from "fj-components/FJButton";

import Style from "./FJUnsupportSafariModal.module.less"

class FJUnsupportSafariModal extends Component {
    render() {
        return (
            <div className={Style.box}>
                <div className={Style.inBox}>
                    <img src={browserNotSupport}/>
                    <div className={Style.text}>{FJLocalStore._("browser-not-support")}</div>
                    <FJButton text={FJLocalStore._('ok')} className={Style.confirm} onClick={this.props.onCancel}/>
                </div>
            </div>
        );
    }
}

export default FJUnsupportSafariModal;